export class UpdateConveyanceRequest {
  Name: string;
  From: string;
  To: string;
  Description: string;
}
